import {
  CheckCircleOutlined,
  ClockCircleOutlined,
  CloseCircleOutlined,
  SyncOutlined,
} from '@ant-design/icons';
import { Tag, Tooltip } from 'antd';
import { ReactNode } from 'react';

import {
  AutopsyActStatus,
  AutopsyActStatusColor,
  AutopsyActStatusLabel,
  ProcessingStage,
  ProcessingStageColor,
  ProcessingStageLabel,
} from '@/shared/pathology/enums';

const stageIcons: Record<ProcessingStage, ReactNode> = {
  [ProcessingStage.QUEUED]: <ClockCircleOutlined />,
  [ProcessingStage.TRANSCRIBING]: <SyncOutlined spin />,
  [ProcessingStage.EXTRACTING]: <SyncOutlined spin />,
  [ProcessingStage.DONE]: <CheckCircleOutlined />,
  [ProcessingStage.FAILED]: <CloseCircleOutlined />,
};

export const ActStatusTag = ({ status }: { status?: AutopsyActStatus | null }) =>
  status ? (
    <Tag color={AutopsyActStatusColor[status]}>{AutopsyActStatusLabel[status]}</Tag>
  ) : null;

interface IProcessingStageTagProps {
  stage?: ProcessingStage | null;
  error?: string | null;
}

// Стадия обработки записи; у ошибки текст причины — в подсказке
export const ProcessingStageTag = ({ stage, error }: IProcessingStageTagProps) => {
  if (!stage) return <>—</>;

  const tag = (
    <Tag color={ProcessingStageColor[stage]} icon={stageIcons[stage]}>
      {ProcessingStageLabel[stage]}
    </Tag>
  );

  return stage === ProcessingStage.FAILED ? (
    <Tooltip title={error || 'Причина ошибки не указана'}>{tag}</Tooltip>
  ) : (
    tag
  );
};
